import { render, staticRenderFns } from "./FirmwareList.vue?vue&type=template&id=83bc819a&"
import script from "./FirmwareList.vue?vue&type=script&lang=js&"
export * from "./FirmwareList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports